module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 full-width"
  }, [_c('div', {
    staticClass: "chart-heading mb-2 ml-1"
  }, [_vm._v(_vm._s(_vm.chart.name))]), _vm._v(" "), (!_vm.chart.columns) ? _c('p', [_vm._v("No Columns")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "chart-outline"
  }, [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.chart.columns), function(column) {
    return _c('td', {
      staticClass: "chart-column"
    }, [_c('div', {
      staticClass: "chart-header"
    }, [_vm._v("\n                " + _vm._s(column.title) + "\n            ")])])
  })], 2), _vm._v(" "), _vm._l((_vm.transactions), function(transaction) {
    return _c('tr', {
      staticClass: "chart-row"
    }, [_c('td', {
      staticStyle: {
        "background-color": "#ccc",
        "width": "8px",
        "padding": "0"
      }
    }), _vm._v(" "), _vm._l((_vm.chart.columns), function(column) {
      return _c('td', {
        staticClass: "chart-column"
      }, [_c('div', {
        staticClass: "chart-cell"
      }, [_c('a', {
        staticClass: "transparent",
        attrs: {
          "href": _vm.transactionLink(transaction.meta.key),
          "target": "_blank"
        }
      }, [_c('ChartControl', {
        attrs: {
          "record": transaction,
          "definition": column
        }
      })], 1)])])
    })], 2)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf4a0f7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Charts/ProgressChart.vue
// module id = 2658
// module chunks = 1